module.exports = __webpack_public_path__ + "img/biaozhun-jilu.da2f5cdd.svg";